import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UserOne } from '@models/userone';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-password-change-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './app-password-change-form.component.html',
  styleUrl: './app-password-change-form.component.css'
})
export class AppPasswordChangeFormComponent {
  @Input() user: UserOne;
  @Input() editMode: boolean = false;
  @Input() userPassForm: FormGroup;
  @Output() saveChanges = new EventEmitter<void>();
  @Output() editModeChange = new EventEmitter<boolean>();

  onSubmit(): void {
    if (this.userPassForm?.valid) {
      console.log('Form Submitted', 'alter password form');
      this.saveChanges.emit();
    }
    console.log('Form Not ValidSubmitted', 'alter password form');
  }

  onCancel(): void {
    this.editMode = false;
    this.editModeChange.emit(this.editMode);
  }
}
